import IconClose from '@mnd-frontend/icons/components/Close';
import { formatUrl } from '@mnd-frontend/ui/public/utils/formatters/url';
import Link from 'next/link';
import type { Dispatch, SetStateAction } from 'react';
import styled, { css } from 'styled-components';
import type { PageFragment } from '../../../wp-generated/types';

const Container = styled.section<{ $open?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: var(--color-purple);
  padding: var(--spacing-medium);
  color: var(--color-white);
  gap: 5px;
  position: relative;
  margin-top: var(--header-height);

  ${({ $open }) =>
    !$open &&
    css`
      display: none;
    `}

  @media (min-width: 768px) {
    justify-content: center;
  }
`;

const TextContainer = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
  flex-wrap: wrap;

  @media (min-width: 400px) {
    flex-direction: row;
  }

  a {
    font-size: var(--font-size-large);
    font-weight: var(--font-weight-semi-bold);
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }
`;

const Text = styled.div`
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semi-bold);
`;

const CloseIcon = styled.div`
  right: var(--spacing-medium);
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  > svg {
    width: 25px;
    height: 39px;
  }
`;

const Notice = ({
  notice,
  noticeIsOpen,
  setNoticeIsOpen,
}: {
  notice?: NonNullable<PageFragment['stickyModules']>['notice'];
  noticeIsOpen: boolean;
  setNoticeIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <Container $open={noticeIsOpen}>
      <TextContainer>
        <Text>{notice?.title}</Text>
        {notice?.link?.url && (
          <Link
            href={formatUrl(notice.link.url)}
            target={notice?.link?.target || ''}
            prefetch={false}
          >
            {notice?.link?.title}
          </Link>
        )}
      </TextContainer>
      <CloseIcon onClick={() => setNoticeIsOpen(false)}>
        <IconClose $size="sm" />
      </CloseIcon>
    </Container>
  );
};
export default Notice;
